/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Unlink_CtaInputs */

const he_account_delivery_whatsapp_unlink_cta = /** @type {(inputs: Account_Delivery_Whatsapp_Unlink_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניתוק ווטסאפ`)
};

const en_account_delivery_whatsapp_unlink_cta = /** @type {(inputs: Account_Delivery_Whatsapp_Unlink_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink WhatsApp`)
};

/**
* | output |
* | --- |
* | "Unlink WhatsApp" |
*
* @param {Account_Delivery_Whatsapp_Unlink_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_unlink_cta = /** @type {((inputs?: Account_Delivery_Whatsapp_Unlink_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Unlink_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_unlink_cta(inputs)
	return en_account_delivery_whatsapp_unlink_cta(inputs)
});